import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";

const API_BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

export default function LoginPage() {
  const navigate = useNavigate();
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkSession = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/session`, {
          method: "GET",
          credentials: "include",
        });

        const data = await response.json().catch(() => ({}));
        if (isMounted && data.ok === true) {
          navigate("/admincms", { replace: true });
          return;
        }
      } catch {
        // Ignore and keep login page visible.
      } finally {
        if (isMounted) {
          setIsCheckingSession(false);
        }
      }
    };

    checkSession();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  if (isCheckingSession) {
    return null;
  }

  return (
    <div className="min-h-screen bg-sky-950 flex flex-col items-center justify-center px-4 py-12">
      {/* Subtle decorative background pattern */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 overflow-hidden"
      >
        {/* Top-right blob */}
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-cyan-500/5" />
        {/* Bottom-left blob */}
        <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-cyan-500/5" />
        {/* Grid lines */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "linear-gradient(oklch(0.93 0.04 185) 1px, transparent 1px), linear-gradient(90deg, oklch(0.93 0.04 185) 1px, transparent 1px)",
            backgroundSize: "48px 48px",
          }}
        />
      </div>

      <main
        id="main-content"
        className="relative z-10 w-full flex flex-col items-center"
      >
        {/* IMC wordmark above card */}
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-2">
            <span className="text-cyan-500 font-extrabold text-2xl tracking-tight">
              CMS
            </span>
            <span className="w-px h-5 bg-white/20" aria-hidden="true" />
            <span className="text-white/50 text-sm font-medium tracking-wide">
              Pesantren Idrisiyyah
            </span>
          </span>
        </div>

        <LoginForm />

        <p className="mt-8 text-white/25 text-xs text-center">
          &copy; {new Date().getFullYear()} Content Management System Pesantren
          Idrisiyyah. All rights reserved.
        </p>
      </main>
    </div>
  );
}
